import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IImageElement) {
    IImageElement.build = function(partial) {
        return _object_spread({
            on_click: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IImageElement || (IImageElement = {}));
export var IImageElement;
